import { cn } from '@/lib/shadcn/utils';
import type { CandidateOriginApi } from '@/modules/candidates/types';

const ORIGIN_STYLES: Record<CandidateOriginApi, string> = {
  Inbound: 'border-primary-600 bg-secondary-150 text-primary-700',
  Outbound: 'border-neutral-300 bg-transparent text-neutral-500',
};

interface CandidateOriginTagProps {
  origin: CandidateOriginApi;
}

/**
 * The candidate's Candidate Origin for this job, beside the status pill.
 * Not a button: the status pill next to it already toggles its own detail.
 */
export function CandidateOriginTag({ origin }: CandidateOriginTagProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium uppercase',
        ORIGIN_STYLES[origin],
      )}
    >
      {origin}
    </span>
  );
}
